import { render, staticRenderFns } from "./MyWalletTokensTable.vue?vue&type=template&id=08947fba&scoped=true"
import script from "./MyWalletTokensTable.vue?vue&type=script&lang=ts"
export * from "./MyWalletTokensTable.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletTokensTable.vue?vue&type=style&index=0&id=08947fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08947fba",
  null
  
)

export default component.exports